/* RESPONSIBLE TEAM: team-inbox */
import ApplicationAdapter from '../application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'inbox/admin_app_sidebar_sections/available_sections';
  },
});
